<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-dropdown #country
                            [isDisabled]="isEdit"
                            [inputFormatter]="typeahead.inputTextNameFormatter"
                            [resultFormatter]="typeahead.inputTextNameFormatter"
                            [resultsFunction]="searchCountries"
                            (inputValueChange)="countryInputChange($event)"
                            [messages]="countryInputMessages"
                            [warningLevel]="WarningsEnum.WARNING_SAVE"
                            baseCypressTag="business-settings-add-country"
                            label="Country/Region"
                            placeholder="Please, search and select a country/region"></app-input-dropdown>

        <div class="country-dynamic-info">
            <div class="country-dynamic-info-alphacode2">
                <div class="modal-info-label" data-cy="alphacode2-label">Alphacode 2</div>
                <div class="modal-info-value"
                     data-cy="alphacode2-input">{{$safeNavigationMigration(state?.currentValue?.alpha2Code) | undefinedValue}}</div>
            </div>
            <div class="country-dynamic-info-alphacode3">
                <div class="modal-info-label" data-cy="alphacode3-label">Alphacode 3</div>
                <div class="modal-info-value"
                     data-cy="alphacode3-input">{{$safeNavigationMigration(state?.currentValue?.alpha3Code) | undefinedValue}}</div>
            </div>
            <div class="country-dynamic-info-numeric-code">
                <div class="modal-info-label" data-cy="numericCode-label">Numeric code</div>
                <div class="modal-info-value"
                     data-cy="numericCode-input">{{$safeNavigationMigration(state?.currentValue?.numericCode) | undefinedValue}}</div>
            </div>
        </div>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>
</app-generic-modal>
